import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'cigna-filters-bar-shared',
  templateUrl: './filters-bar.component.html',
  styleUrls: ['./filters-bar.component.scss'],
})
export class FiltersBarSharedComponent {
  @Input() isExpanded = false;
  @Input() isValid = true;

  @Output() applyFilters = new EventEmitter();
  @Output() resetFilters = new EventEmitter();
  @Output() toggleFilters = new EventEmitter();
}
